export const REACT_API_KEY = `https://college-backend-vkln.onrender.com/api`;